module.exports = __webpack_public_path__ + "static/media/004.1cd64272.svg";